"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _NotifyItem = _interopRequireDefault(require("./NotifyItem.style"));
var _Stack = _interopRequireDefault(require("../../Stack"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Label = _interopRequireDefault(require("../../Label"));
var _cr = _interopRequireDefault(require("../../utils/cr"));
var _constants = require("../../constants");
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AUTO_HIDE_TIMEOUT = 5000;
let NotifyItem = (_dec = (0, _reactJss.default)(_NotifyItem.default), _dec(_class = class NotifyItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    const {
      onClose,
      id
    } = this.props;
    onClose({
      id
    });
  }
  componentDidMount() {
    const {
      expire,
      hideDelay
    } = this.props;
    if (expire !== 'none') {
      setTimeout(this.handleClose, hideDelay || AUTO_HIDE_TIMEOUT);
    }
  }
  getIcon(icon) {
    const {
      classes
    } = this.props;
    return (0, _cr.default)([(0, _react.isValidElement)(icon), icon], [icon, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.icon,
      type: icon,
      size: "medium",
      color: 'currentColor'
    })], [true, null]);
  }
  render() {
    const {
      id,
      classes,
      className,
      label,
      icon,
      type,
      helperText,
      closeIcon,
      borderRadius,
      content,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(classes.notifyItem, classes[type], classes[`borderRadius__${borderRadius}`], className),
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      className: (0, _clsx.default)(classes.titleContainer),
      size: "small",
      alignItems: "center",
      fullWidth: true
    }, this.getIcon(icon), label ? /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.title),
      value: label,
      fontSize: "medium"
    }) : null, content, closeIcon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.closeIcon),
      type: "close",
      size: "micro",
      color: 'currentColor',
      onClick: this.handleClose,
      dataTestId: dataTestId ? `${dataTestId}-close-icon` : undefined
    }) : null), helperText ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.descriptionContainer)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.description),
      value: helperText,
      fontSize: "medium"
    })) : null);
  }
}) || _class);
NotifyItem.BORDER_RADIUS = _constants.BORDER_RADIUS;
NotifyItem.TYPE = {
  normal: 'normal',
  error: 'error',
  success: 'success',
  primary: 'primary'
};
NotifyItem.defaultProps = {
  type: 'normal',
  borderRadius: 'small',
  expire: 'auto',
  closeIcon: true,
  onClose: () => {}
};
var _default = exports.default = NotifyItem;